module.exports = "<div id=\"auth-status-page-id\">\r\n\t\r\n\t<app-auth-status></app-auth-status>\r\n\r\n</div>\r\n"